if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia("(min-width: 768px)");
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener(
          "slideChanged",
          debounce(this.onSlideChanged.bind(this), 500)
        );
        this.elements.thumbnails
          .querySelectorAll("[data-target]")
          .forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector("button")
              .addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
          });

        // Store media-variant relationships on load
        this.mediaVariantMap = this.buildMediaVariantMap();

        if (
          this.dataset.desktopLayout.includes("thumbnail") &&
          this.mql.matches
        )
          this.removeListSemantic();
      }

      // onSlideChanged(event) {
      //   const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      //   this.setActiveThumbnail(thumbnail);
      // }
      onSlideChanged(event) {
        if (!event.detail || !event.detail.currentElement) {
          return;
        }
        const currentElement = event.detail.currentElement;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia = this.elements.viewer.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        this.elements.viewer
          .querySelectorAll("[data-media-id]")
          .forEach((element) => {
            element.classList.remove("is-active");
          });
        activeMedia.classList.add("is-active");

        // Update variant selection when image is clicked (if not triggered by variant change)
        if (!prepend) {
          this.updateVariantBasedOnMedia(mediaId);
        }

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
            });
          }
          if (
            !this.elements.thumbnails ||
            this.dataset.desktopLayout === "stacked"
          ) {
            activeMedia.scrollIntoView({ behavior: "smooth" });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(
          activeMedia,
          activeThumbnail.dataset.mediaPosition
        );
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector("sticky-header");
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }

      // Build a map of media IDs to variant IDs
      buildMediaVariantMap() {
        const mediaMap = {};
        const productSection = this.closest(".product");
        if (!productSection) return mediaMap;

        // Find the variant-selects element
        const variantSelects = productSection.querySelector("variant-selects");
        if (!variantSelects) return mediaMap;

        try {
          // Get variants data from the JSON script inside variant-selects
          const variantsScript = variantSelects.querySelector(
            'script[type="application/json"]'
          );
          if (!variantsScript) return mediaMap;

          const variants = JSON.parse(variantsScript.textContent);

          // Build the mapping of media to variants
          variants.forEach((variant) => {
            if (variant.featured_media) {
              const sectionId = variantSelects.dataset.section;
              const mediaId = `${sectionId}-${variant.featured_media.id}`;

              if (!mediaMap[mediaId]) {
                mediaMap[mediaId] = [];
              }

              mediaMap[mediaId].push({
                id: variant.id,
                options: variant.options,
                available: variant.available,
              });
            }
          });
        } catch (error) {
          console.error("Error building media-variant map:", error);
        }

        return mediaMap;
      }

      // Update the variant selection based on the active media
      updateVariantBasedOnMedia(mediaId) {
        if (
          !this.mediaVariantMap ||
          !this.mediaVariantMap[mediaId] ||
          this.mediaVariantMap[mediaId].length === 0
        ) {
          return;
        }

        const productSection = this.closest(".product");
        if (!productSection) return;

        const variantSelects = productSection.querySelector("variant-selects");
        if (!variantSelects) return;

        // Prioritize available variants first
        const matchingVariants = this.mediaVariantMap[mediaId];
        const variantToUse =
          matchingVariants.find((v) => v.available) || matchingVariants[0];

        if (!variantToUse) return;

        // Update dropdown and radio selectors based on the variant options
        const selects = variantSelects.querySelectorAll("select");
        const fieldsets = variantSelects.querySelectorAll("fieldset");

        if (selects.length > 0) {
          // For dropdown selectors
          selects.forEach((select, index) => {
            if (index < variantToUse.options.length) {
              const optionValue = variantToUse.options[index];

              // Find the option with this value
              const option = Array.from(select.options).find(
                (opt) => opt.value === optionValue
              );
              if (option) {
                select.value = optionValue;
                select.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
          });
        } else if (fieldsets.length > 0) {
          // For radio button selectors
          fieldsets.forEach((fieldset, index) => {
            if (index < variantToUse.options.length) {
              const optionValue = variantToUse.options[index];

              // Find the radio button with this value
              const radio = fieldset.querySelector(
                `input[value="${optionValue}"]`
              );
              if (radio) {
                radio.checked = true;
                radio.dispatchEvent(new Event("change", { bubbles: true }));
              }
            }
          });
        }
      }
    }
  );
}
